/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import { list, getListSelect } from '../../service/channel';
import {sKeylist} from '../../service/dictionary/dataitem';
import {allChildren} from '../../service/zone';
import {Store, Actions} from './store';

class ChannelList extends React.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      filterBoxVisible: false,
      options: [],
      channels: [],
      channel_type: [],
      channel_rank: [],
      rows: [],
      total: 0,
      searchObj: {
        code: '',
        name: '',
        channelType: '',
        contacts: '',
        areaId: null,
        parentId: null,
        s: 10,
        p: 1,
      }
    }

    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'channel' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
    }
  }

  componentWillMount(){ //准备数据
    const self = this;
    const data = this.store.state;
    if(data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }
    allChildren({id: 0}).then(res => { //归属区域
      if(res.data && res.data.length>0){
        let timer = window.setInterval(function(){
          if(self.mounted){
            window.clearInterval(timer);
            self.setState({options: res.data});
          }
        }, 0);
      }
    });
    getListSelect().then(res => { //上级渠道
      if(res.data && res.data.length>0){
        const data = res.data.map((x, index) => {
          return {
            ...x,
            value: x.id,
            text: x.name
          }
        });
        let timer = window.setInterval(function(){
          if(self.mounted){
            window.clearInterval(timer);
            self.setState({channels: data});
          }
        }, 0);
      }
    });
    sKeylist({sKey: 'channel_rank'}).then(res => { //渠道等级
      if(res.status){
        let arr = res.data.map(x => {
          return {
            text: x.name,
            value: x.sKey
          }
        })
        let timer = window.setInterval(function(){
          if(self.mounted){
            window.clearInterval(timer);
            self.setState({channel_rank: arr})
          }
        }, 0);
      }
    })
    sKeylist({sKey: 'channel_type'}).then(res => { //渠道类型
      if(res.status){
        let arr = [
          {
            text: '全部',
            value: ''
          }
        ];
        res.data.forEach(x => {
          arr.push({
            text: x.name,
            value: x.sKey
          })
        });
        let timer = window.setInterval(function(){
          if(self.mounted){
            window.clearInterval(timer);
            self.setState({channel_type: arr})
          }
        }, 0);
      }
    })
  }

  componentDidMount() {
    this.mounted = true;
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  goView (url) {
    hashHistory.push(url);
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    const self = this;
    this.setState({
      filterBoxVisible: false,
      searchObj: {
        ...this.state.searchObj,
        code: '',
        name: '',
        channelType: '',
        contacts: '',
        areaId: '',
        parentId: '',
        p: 1,
      }
    }, ()=>{
      self.getData();
    })
  };

  advanceSubmit (form) {
    const self = this;
    this.setState({ filterBoxVisible: false, searchObj: { ...this.state.searchObj, p: 1 } }, function(){
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'lastOperationTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          lastOperationTimeStart: value.from,
          lastOperationTimeEnd: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }

  getData(){
    const self = this;
    const {searchObj} = this.state;
    list(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }

  render () {
    const { filterBoxVisible, rows, total, searchObj, options, channel_type, channels } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'code',
            label: '渠道编码',
            text: '输入渠道编码',
            defaultValue: searchObj.code,
            type: 'default'
          },
          {
            name: 'name',
            label: '企业名称',
            text: '输入企业名称',
            defaultValue: searchObj.name,
            type: 'default'
          },
          {
            name: 'channelType',
            label: '类型',
            text: '选择类型',
            options: channel_type,
            defaultValue: searchObj.channelType,
            multiple: false,//支持多选
            type: 'select'
          },
          {
            name: 'contacts',
            label: '联系人',
            text: '输入联系人姓名',
            defaultValue: searchObj.contacts,
            type: 'default'
          },
          {
            name: 'areaId',
            label: '归属区域',
            text: '输入归属区域',
            dataType: 'number',
            defaultValue: searchObj.areaId !== null ? searchObj.areaId+'' : '',
            options: options,
            type: 'treeSelect'
          },
          {
            name: 'parentId',
            label: '上级渠道',
            text: '输入上级渠道',
            options: channels,
            defaultValue: searchObj.parentId !== null ? searchObj.parentId+'' : '',
            dataType: 'number',
            type: 'select'
          },
          /*{
            name: 'dealer',
            label: '上级渠道',
            text: '选择上级渠道',
            options: [
              { value: '0', text: '经销商0' },
              { value: '1', text: '经销商1' },
              { value: '2', text: '经销商2' },
            ],
            multiple: false,//支持多选
            type: 'select'
          },*/
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '渠道编码',
          dataIndex: 'code'
        }, {
          title: '名称',
          dataIndex: 'name',
          render: (text, record, index) => {
            return <a href={`#/channel/${record.id}`}>{text}</a>
          }
        }, {
          title: '地址',
          dataIndex: 'address',
          render: (text, record, index) => {
            return `${record.provinceText||''}${record.cityText||''}${record.countyText||''}${text||''}`;
          }
        }, /*{
          title: '联系人',
          dataIndex: 'contacts'
        },*/ {
          title: '类型',
          dataIndex: 'channelTypeText'
        }, {
          title: '归属区域',
          dataIndex: 'areaText'
        }, {
          title: '上级渠道',
          dataIndex: 'parentText'
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={[`渠道列表`]} defaultKey={0}>
        <Button icon="plus" onClick={this.goView.bind(this, `/channel/add/0`)}>新增</Button>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default withRouter(ChannelList);


// WEBPACK FOOTER //
// ./src/routes/channel/list.js